export function whereFilterListToJsonArray(whereFilterList) {
  let filt = [];

  whereFilterList.map((fil) => {
    let filtJson = {};
    filtJson.filter_on = {};
    filtJson.filter_on.group = fil?.filter_on?.group;
    filtJson.filter_on.name = fil?.filter_on?.name;
    if (fil?.filter_on?.group === "dataset") {
      // for datasets, the column is also the name. This is not true for automation records. Both use similar filtering functionality in mre
      filtJson.filter_on.column = fil?.filter_on?.name;
    } else if (fil?.filter_on?.group === "automation_records") {
      filtJson.filter_on.column = fil?.filter_on?.column;
      filtJson.filter_on.model_output_name = fil?.filter_on?.modelOutputName; // name of type of prediction we are tying to filter by
    }
    filtJson.comparison_operator = fil?.comparison_operator;
    filtJson.value_datatype = fil?.value_datatype;
    filtJson.filter_value = fil?.filter_value;
    filt.push(filtJson);
  });
  return filt;
}
